<template>
	<div class="newsletter-ai-input">
		<div class="input-container">
			<AppButtonIcon
				v-if="attachmentCount === 0"
				class="attachment-btn"
				icon-name="icon-plus"
				color="var(--color-bg-primary-2)"
				prevent-change
				@click-icon="$emit('add-attachment')"
			/>
			<div
				v-else
				class="attachment-btn attachment-count-btn"
				@click="$emit('add-attachment')"
			>
				<div class="btn-inner">
					{{ attachmentCount }}
				</div>
			</div>
			<AppTextInput
				ref="textarea-input"
				class="ai-textarea"
				textarea
				:readonly="loading"
				:value="value"
				:placeholder="placeholder"
				@changing-text="handleTextChange"
			/>
			<AppButtonIcon
				class="thinking-mode-btn"
				:icon-name="thinkingModeIcon"
				color="var(--color-bg-primary-2)"
				prevent-change
				@click-icon="toggleThinkingMode"
			/>
			<AppButtonIcon
				class="send-btn"
				icon-name="icon-ai-white"
				prevent-change
				:loading="loading"
				@click-icon="$emit('send')"
			/>
		</div>
	</div>
</template>

<script>
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";

export default {
	name: "NewsletterAiInput",
	components: {
		AppTextInput,
		AppButtonIcon
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		attachmentCount: {
			type: Number,
			default: 0
		},
		thinkingMode: {
			type: String,
			default: 'low',
			validator: (value) => ['low', 'high'].includes(value)
		}
	},
	emits: ['update:value', 'send', 'add-attachment', 'update:thinking-mode'],
	computed: {
		thinkingModeIcon() {
			return this.thinkingMode === 'low' ? 'icon-fast' : 'icon-thinking';
		}
	},
	methods: {
		handleTextChange(v) {
			const maxMsgLength = 8000;
			if(v?.length && v.length > maxMsgLength) {
				v = v.slice(0, maxMsgLength);
				const txtArea = this.$refs['textarea-input'].$el.querySelector('textarea');
				if(txtArea) {
					txtArea.value = v;
				}
			}
			this.$emit('update:value', v || '');
		},
		toggleThinkingMode() {
			const newMode = this.thinkingMode === 'low' ? 'high' : 'low';
			this.$emit('update:thinking-mode', newMode);
		}
	}
}
</script>

<style scoped lang="scss">
.newsletter-ai-input {
	width: 100%;
	max-width: 600px;
	position: relative;
	padding: 1px;

	&::before{
		content: "";
		position: absolute;
		inset: 0;
		padding: 1px;
		border-radius: 13px;
		--angle:160deg;
		background: linear-gradient(var(--angle),var(--color-secondary) 0%,#E3216B 27%,#8F4DFE 63%,var(--color-primary) 100%);
		-webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
	}

	.input-container {
		position: relative;
		width: 100%;

		.ai-textarea {
			width: 100%;
		}

		:deep(.input-wrapper) {
			width: 100%;
			.input-element {
				background-color: var(--color-bg-primary-2);
				textarea {
					background-color: transparent;
					padding: 6px 12px 38px;
					height: 120px;
					min-height: 120px;
					max-height: 300px;
				}
			}
		}

		.attachment-btn {
			position: absolute;
			bottom: 8px;
			left: 8px;
			z-index: 1;

			&.attachment-count-btn {
				@include centered;
				width: 35px;
				height: 35px;
				border-radius: 13px;
				box-shadow: 0 1px 2px var(--color-box-shadow-3);
				background-color: var(--color-bg);
				cursor: pointer;
				transition: opacity .2s $transition;

				.btn-inner {
					@include centered;
					box-shadow: inset 0 2px 3px var(--color-box-shadow-dark-2);
					width: 29px;
					height: 29px;
					border-radius: 10px;
					background-color: var(--color-bg-primary-2);
					transition: background-color .2s $transition;
					font-size: 14px;
					font-weight: 600;
					color: var(--color-primary);
				}
			}
		}

		.thinking-mode-btn {
			position: absolute;
			bottom: 8px;
			right: 52px;
			z-index: 1;
		}

		.send-btn {
			position: absolute;
			bottom: 8px;
			right: 8px;
			z-index: 1;
		}
	}
}
</style>
